var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.duplicationWarning.show
      ? _c("div", { staticClass: "duplication-overlay" }, [
          _c("div", { staticClass: "duplication-overlay-content" }, [
            _c("div", { staticClass: "duplication-icon" }, [
              _c("i", { staticClass: "fas fa-copy fa-3x" })
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "mt-4 mb-3" }, [
              _vm._v(_vm._s(_vm.duplicationWarning.message))
            ]),
            _vm._v(" "),
            _vm.duplicationWarning.jobMessage
              ? _c("p", { staticClass: "duplication-subtext mb-4" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.duplicationWarning.jobMessage) +
                      "\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-back",
                on: { click: _vm.goBack }
              },
              [
                _c("i", { staticClass: "fas fa-arrow-left" }),
                _vm._v("\n                Go Back\n            ")
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }